import { render, staticRenderFns } from "./recordsName.vue?vue&type=template&id=1175e31e&"
import script from "./recordsName.vue?vue&type=script&lang=js&"
export * from "./recordsName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports